var _line, _path, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 20,
    viewBox: "0 0 480 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -8.74228e-8,
    y1: 9,
    x2: 204,
    y2: 8.99998,
    stroke: "#B7DB6A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.88 2H235.32L229.86 8.54C228.6 10.04 228 11.48 228 13.1C228 16.34 230.52 18.86 233.76 18.86C236.88 18.86 239.4 16.4 239.4 13.34C239.4 10.82 237.9 9.26 234.84 8.54L239.88 2ZM252.36 2H247.86L242.34 8.54C241.08 10.1 240.48 11.48 240.48 13.1C240.48 16.34 243 18.86 246.24 18.86C249.36 18.86 251.88 16.4 251.88 13.34C251.88 10.82 250.38 9.26 247.32 8.54L252.36 2Z",
    fill: "#B7DB6A"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 276,
    y1: 9,
    x2: 480,
    y2: 8.99998,
    stroke: "#B7DB6A",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.3ac3aec9ab588fd87dfb136966f709a2.svg";
export { ForwardRef as ReactComponent };